import { render, staticRenderFns } from "./SupportView.vue?vue&type=template&id=0a10a0a6&"
import script from "./SupportView.vue?vue&type=script&lang=js&"
export * from "./SupportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports